var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('activity-wrapper', [_vm.currentRound.optionalContent ? _c('section', {
    staticClass: "dynamicContentSection"
  }, [_c('dynamic-content', {
    attrs: {
      "dynamicContent": _vm.currentRound.optionalContent
    }
  })], 1) : _vm._e(), _c('section', {
    staticClass: "question-section"
  }, [_c('div', {
    staticClass: "question"
  }, [_c('html-renderer', {
    attrs: {
      "htmlObject": _vm.currentRound && _vm.currentRound.questionHtml
    }
  })], 1)]), _c('div', {
    staticClass: "answers-container"
  }, [_vm.equationSymbols ? _c('div', {
    staticClass: "answers"
  }, [_c('div', {
    staticClass: "equation"
  }, [_vm._l(_vm.equationSymbols, function (symbol) {
    return [symbol.fraction ? _c('div', {
      staticClass: "fraction-container"
    }, [_c('div', {
      staticClass: "fraction-row"
    }, [_vm._l(symbol.fraction.numerator, function (fractionedSymbol) {
      return [fractionedSymbol.isAnswer ? [_c('answer-input', {
        ref: "answerInputs",
        refInFor: true,
        staticClass: "number-input",
        attrs: {
          "answer": _vm.showAnswers && !_vm.disabled[fractionedSymbol.index] ? fractionedSymbol.characters.toString() : '',
          "maxLength": 3,
          "error": _vm.errors[fractionedSymbol.index],
          "disabled": _vm.disabled[fractionedSymbol.index]
        },
        on: {
          "input": function ($event) {
            _vm.answers[fractionedSymbol.index] = $event;
          }
        }
      })] : [_c('span', {
        staticClass: "inline-operators"
      }, [_vm._v(_vm._s(fractionedSymbol.characters))])]];
    })], 2), _c('hr', {
      staticStyle: {
        "width": "100%"
      }
    }), _c('div', {
      staticClass: "fraction-row"
    }, [_vm._l(symbol.fraction.denominator, function (fractionedSymbol) {
      return [fractionedSymbol.isAnswer ? [_c('answer-input', {
        ref: "answerInputs",
        refInFor: true,
        staticClass: "number-input",
        attrs: {
          "answer": _vm.showAnswers && !_vm.disabled[fractionedSymbol.index] ? fractionedSymbol.characters.toString() : '',
          "maxLength": 3,
          "error": _vm.errors[fractionedSymbol.index],
          "disabled": _vm.disabled[fractionedSymbol.index]
        },
        on: {
          "input": function ($event) {
            _vm.answers[fractionedSymbol.index] = $event;
          }
        }
      })] : [_c('span', {
        staticClass: "inline-operators"
      }, [_vm._v(_vm._s(fractionedSymbol.characters))])]];
    })], 2)]) : [symbol.isAnswer ? [_c('answer-input', {
      ref: "answerInputs",
      refInFor: true,
      staticClass: "number-input",
      attrs: {
        "answer": _vm.showAnswers && !_vm.disabled[symbol.index] ? symbol.characters.toString() : '',
        "maxLength": 3,
        "error": _vm.errors[symbol.index],
        "disabled": _vm.disabled[symbol.index]
      },
      on: {
        "input": function ($event) {
          _vm.answers[symbol.index] = $event;
        }
      }
    })] : [_c('span', {
      staticClass: "inline-operators"
    }, [_vm._v(_vm._s(symbol.characters))])]]];
  })], 2), _c('div', {
    staticClass: "icon-container"
  }, [_vm.isComplete ? _c('success-check-solid-icon', {
    attrs: {
      "iconName": "Success Check Solid Icon",
      "height": "26",
      "width": "37"
    }
  }) : _vm._e(), _vm.showErrors ? _c('red-x-solid-icon', {
    attrs: {
      "iconName": "Red X Outine Icon",
      "height": "26",
      "width": "27"
    }
  }) : _vm._e()], 1)]) : _vm._e(), _c('div', {
    staticClass: "keyboard-positioning-wrapper"
  }, [_c('number-pad-keyboard')], 1)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }